export class PaletteHelpers {
  /**
   * Convert hex code to rgb object
   * @param {string} hex - Hex color code
   * @returns {object} RGB values
   */
  static hexToRgb(hex) {
    hex = hex.replace('#', '');
    return {
      r: parseInt(hex.slice(0, 2), 16),
      g: parseInt(hex.slice(2, 4), 16),
      b: parseInt(hex.slice(4, 6), 16)
    };
  }

  /**
   * Get random integer between min and max (inclusive)
   * @param {number} min
   * @param {number} max
   * @returns {number}
   */
  static randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Get random element from array
   * @param {array} arr
   * @returns {*}
   */
  static randomArrayElement(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  /**
   * Returns a random color from the palette array
   * @param {string|array|null} rank - Should match a palette type (primary, secondary, tertiary)
   * @param {boolean} bland - If true, will include bland colors like blacks and gray
   * @returns {string|false}
   */
  static getRandomColor(rank = null, bland = false) {
    if (!window.pratt || !window.pratt.palettes) {
      return false;
    }

    const palettes = window.pratt.palettes;

    // Handle array of ranks
    if (Array.isArray(rank)) {
      const validRanks = rank.filter(r => Object.prototype.hasOwnProperty.call(palettes, r));
      if (validRanks.length === 0) {
        return false;
      }
      rank = this.randomArrayElement(validRanks);
    }

    // Handle null rank (pick any random rank)
    if (!rank) {
      const ranks = Object.keys(palettes);
      rank = this.randomArrayElement(ranks);
    }

    // Handle single string rank
    if (!Object.prototype.hasOwnProperty.call(palettes, rank)) {
      return false;
    }

    let colors = palettes[rank];

    // Filter out bland colors if needed
    if (!bland) {
      const blandColors = ['#000000', '#FFFFFF', '#B7B8B9', '#B4ACA6'];
      const filteredColors = {};

      Object.keys(colors).forEach(colorName => {
        if (!blandColors.includes(colors[colorName])) {
          filteredColors[colorName] = colors[colorName];
        }
      });

      if (Object.keys(filteredColors).length === 0) {
        return false;
      }

      colors = filteredColors;
    }

    const hexCodes = Object.values(colors);
    return this.randomArrayElement(hexCodes);
  }

  /**
   * Returns a random css string to use in a gradient
   * @param {string|array|null} rank - Should match a palette type (primary, secondary, tertiary)
   * @param {number|null} angle - Angle of gradient
   * @param {boolean} bland - If true, will include bland colors like blacks and gray
   * @returns {string|false}
   */
  static getRandomGradient(rank = null, angle = null, bland = false) {
    const hexColor = this.getRandomColor(rank, bland);

    if (!hexColor) {
      return false;
    }

    const rgb = this.hexToRgb(hexColor);

    if (!angle) {
      angle = this.randomInt(0, 360);
    }

    return `linear-gradient(${angle}deg, ${hexColor}, rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0))`;
  }
}
